module.exports = __webpack_public_path__ + "img/united-kingdom.67184f51.svg";